module.exports = __webpack_public_path__ + "static/img/vip-info4.48778e7c.png";